import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { roleAccesscolumns } from './RoleAccessTableData';
import DataTable from '../../../../Common/DataTable/DataTable';
import api, { RBAC_BASE } from '../../../../api/rbacApi';

const RoleAccessTable = () => {
  const [dataT, setDataT] = useState([]);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await api.get(`${RBAC_BASE}/user-role-mapping`);
    setDataT(res.data);
  };

  const formattedData = dataT.map((data) => ({
    id: data.intUserId,
    userName: data.vchFullName,
    roleName: data.nvchDesigName || "Not Assigned",

    action: (
      <Link to={`/role-assign/${data.intUserId}`} className="btn btn-sm btn-outline-primary">
        <i className="bi bi-pencil-square"></i>
      </Link>
    ),
  }));

  return (
    <div className="admin-table-shell">
      <DataTable columns={roleAccesscolumns} data={formattedData} />
    </div>
  );
};

export default RoleAccessTable;